import { useState, useEffect } from 'react';

interface UseRedirectCountdownOptions {
  initialSeconds: number;
  onComplete?: () => void;
}

export const useRedirectCountdown = ({
  initialSeconds,
  onComplete,
}: UseRedirectCountdownOptions) => {
  const [remainingSeconds, setRemainingSeconds] = useState(initialSeconds);

  useEffect(() => {
    if (remainingSeconds <= 0) {
      onComplete?.();
      return;
    }

    const timer = setInterval(() => {
      setRemainingSeconds((prev) => {
        const next = prev - 1;
        if (next <= 0) {
          clearInterval(timer);
          onComplete?.();
        }
        return next;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [remainingSeconds, onComplete]);

  return remainingSeconds;
};
